import ThronVideo from '@components/utils/ThronVideo';
import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
const ProductVideo = (props) => {
    const { t } = useTranslation();
    const pdpVideoRef = useRef(null);
    function findElementWithPauseAttribute(videoElement) {
        let currentElement = videoElement.parentNode;
        while (currentElement !== document) {
            const pauseElement = currentElement.querySelector('[data-pause]');
            if (pauseElement) {
                return pauseElement;
            }
            currentElement = currentElement.parentNode;
        }
        return null; // Se non viene trovato nessun elemento con l'attributo data-pause
    }
    useEffect(() => {
        let pauseButton;
        const onPause = (e) => {
            const currentButton = e.target;
            if (currentButton.ariaPressed === 'true') {
                currentButton.setAttribute('aria-pressed', 'false');
                if (props.inZoomModal) {
                    pdpVideoRef.current
                        .closest('.product-zoom-modal')
                        .querySelectorAll('.product-zoom-thumbs--wrapper video')
                        .forEach((v) => {
                        if (pdpVideoRef.current.src === v.src) {
                            v.play();
                        }
                    });
                    pdpVideoRef.current.play();
                }
                else {
                    pdpVideoRef.current.play();
                }
            }
            else {
                currentButton.setAttribute('aria-pressed', 'true');
                pdpVideoRef.current.pause();
                if (props.inZoomModal) {
                    pdpVideoRef.current
                        .closest('.product-zoom-modal')
                        .querySelectorAll('.product-zoom-thumbs--wrapper video')
                        .forEach((v) => {
                        if (pdpVideoRef.current.src === v.src) {
                            v.pause();
                        }
                    });
                    pdpVideoRef.current.pause();
                }
                else {
                    pdpVideoRef.current.pause();
                }
            }
        };
        if (pdpVideoRef.current) {
            pauseButton = findElementWithPauseAttribute(pdpVideoRef.current);
            if (pauseButton && !props.isThumb) {
                pauseButton.addEventListener('click', onPause);
            }
        }
        return () => pauseButton === null || pauseButton === void 0 ? void 0 : pauseButton.removeEventListener('click', onPause);
    });
    const videoElement = props.url ? (React.createElement("video", { ref: pdpVideoRef, className: classNames('wrapper-product-video', { 'is-parfum': props.isParfum }), playsInline: true, autoPlay: true, muted: true, loop: true, src: props.url })) : (React.createElement(ThronVideo, { thronID: props.tronID, autoplay: true, muted: true, className: classNames('product-video-wrapper'), sessionId: props.sessionId, lockBitrate: window.lockBitrateProductVideos }));
    if (props.inGallery) {
        return (React.createElement("div", { className: "wrapper-product-video" },
            videoElement,
            !props.isThumb && React.createElement("button", { className: "product-video-pause", "aria-label": t('button.pause'), "data-pause": true, "aria-pressed": "false" })));
    }
    return videoElement;
};
export default ProductVideo;
